"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("core/api");
const constants_1 = require("core/constants");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const view_utils_1 = require("utils/view-utils");
const ampli_1 = require("../../ampli");
class HeaderMenu extends React.Component {
    getArchivedSeasonsForTeam(team) {
        const { teams } = this.props;
        return (0, lodash_1.filter)(teams, (t) => t.isArchivedSeason && t.activeSeasonTeamId === team.id);
    }
    renderTeamMenuItems() {
        const { isCommissionerOfAnything, activeTeams, retiredTeams, teamsLoaded } = this.props;
        if (!teamsLoaded)
            return null;
        const teamLink = (t) => {
            const archivedSeasons = this.getArchivedSeasonsForTeam(t);
            return (React.createElement("li", { key: t.id, className: "dropdown__item teams" },
                React.createElement("a", { href: `${constants_1.TEAMSNAP_URL}/${t.id}/home` }, t.name),
                archivedSeasons.length > 0 && (React.createElement("ul", null,
                    React.createElement("li", { className: "flyout__item" }, "Archived Seasons"),
                    (0, lodash_1.map)(archivedSeasons, (at) => (React.createElement("li", { key: at.id, className: "archived-teams flyout__item" },
                        React.createElement("a", { href: `${constants_1.TEAMSNAP_URL}/${at.id}/home` }, at.seasonName))))))));
        };
        if (activeTeams.length === 0 && retiredTeams.length === 0) {
            if (isCommissionerOfAnything) {
                return (React.createElement("ul", null,
                    React.createElement("li", { className: "dropdown__flyout" },
                        React.createElement("small", null, "Sorry, you're not on any teams."))));
            }
            return (React.createElement("ul", null,
                React.createElement("li", { className: "dropdown__flyout" },
                    React.createElement("small", null, "Sorry, you're not on any teams. Would you like to create one?")),
                React.createElement("li", { className: "dropdown__item" },
                    React.createElement("a", { id: "new-team-link", href: constants_1.TEAMSNAP_URL + '/team/new', onClick: () => ampli_1.ampli.createTeamButtonClicked({
                            screen_name: 'Unknown',
                            onboarding_button_name: 'Create new team',
                        }) }, "Create a New Team"))));
        }
        return (React.createElement("ul", null,
            (0, lodash_1.map)((0, lodash_1.sortBy)(activeTeams, 'name'), teamLink),
            retiredTeams.length > 0 && (React.createElement("li", { className: "flyout__item" },
                React.createElement("a", { id: "retired-teams", href: constants_1.TEAMSNAP_URL + '/team/dashboard', className: "flyout__title" }, "Retired Teams"),
                React.createElement("ul", null, (0, lodash_1.map)((0, lodash_1.sortBy)(retiredTeams, 'name'), teamLink)))),
            !isCommissionerOfAnything && (React.createElement("li", { className: "flyout__item" },
                React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/team/new' }, "Create a New Team")))));
    }
    renderLeagueMenuItems() {
        const { membersLoaded, myLeagues } = this.props;
        if (!membersLoaded)
            return null;
        return (React.createElement("ul", { id: "leagues-list" }, (0, lodash_1.map)((0, lodash_1.sortBy)(myLeagues, 'name'), (d) => (React.createElement("li", { key: d.id, className: "flyout__item" },
            React.createElement("a", { href: `${constants_1.TEAMSNAP_URL}/team/set_division/${d.id}` }, d.name))))));
    }
    renderNavMenu() {
        const { isCommissionerOfAnything } = this.props;
        const teamLink = constants_1.TEAMSNAP_URL + '/team/dashboard';
        if (isCommissionerOfAnything) {
            return (React.createElement("li", { className: "button-group__button--ss-dropdown-after" },
                React.createElement("a", { href: teamLink, className: "dropdown__title" }, "My Teams & Leagues"),
                React.createElement("ul", null,
                    React.createElement("li", { className: "dropdown__flyout" },
                        React.createElement("a", { href: teamLink, className: "flyout__title" }, "My Leagues"),
                        this.renderLeagueMenuItems()),
                    React.createElement("li", { className: "dropdown__flyout" },
                        React.createElement("a", { href: teamLink, className: "flyout__title" }, "My Teams"),
                        this.renderTeamMenuItems()))));
        }
        return (React.createElement("li", { className: "button-group__button--ss-dropdown-after" },
            React.createElement("a", { href: teamLink, className: "dropdown__title" }, "My Teams"),
            this.renderTeamMenuItems()));
    }
    render() {
        const { user } = this.props;
        const teamLink = constants_1.TEAMSNAP_URL + '/account?view=teams';
        const billingLink = constants_1.TEAMSNAP_URL + '/account?view=billing';
        const newTeamLink = constants_1.TEAMSNAP_URL + '/team/new';
        const signoutLink = constants_1.TEAMSNAP_URL + '/login/signout';
        return (React.createElement("ul", { className: "App-Header__button-group--pull-right-sm" },
            this.renderNavMenu(),
            React.createElement("li", { className: "button-group__button--ss-dropdown-after" },
                React.createElement("a", { href: "/", className: "dropdown__title" }, "Account"),
                React.createElement("ul", { className: "Account-Dropdown" },
                    React.createElement("li", { className: "dropdown__item" },
                        React.createElement("h3", { className: "Account-Dropdown__user" }, (0, view_utils_1.fullName)(user)),
                        React.createElement("small", { className: "Account-Dropdown__email" }, user.email),
                        React.createElement("a", { href: "/" }, "My Account")),
                    React.createElement("li", { className: "dropdown__item" },
                        constants_1.SHOW_FAMILY_MANAGEMENT && React.createElement("a", { href: "/settings/household" }, "My Household"),
                        React.createElement("a", { href: teamLink }, "Manage My Teams"),
                        React.createElement("a", { href: billingLink }, "Billings and Plans"),
                        React.createElement("a", { href: newTeamLink, onClick: () => ampli_1.ampli.createTeamButtonClicked({
                                screen_name: 'Unknown',
                                onboarding_button_name: 'Create new team',
                            }) }, "Create a New Team")),
                    user.capabilities?.includes(api_1.UserCapability.NAVIGATION_GO_TO_TS1) && (React.createElement("li", { className: "dropdown__item" },
                        React.createElement("a", { href: constants_1.IDENTITY_URL, target: "_blank", rel: "noopener noreferrer" }, "Go to TeamSnap ONE"))),
                    React.createElement("li", { className: "dropdown__item" },
                        React.createElement("a", { href: signoutLink, className: "Account-Dropdown__sign-out" }, "Sign Out"))))));
    }
}
exports.default = HeaderMenu;
